import React from 'react'
import Modal from './Modal'
import { useModal } from 'contexts/ModalContext'
import { useCarrito } from 'contexts/CarritoContext'
import { showToast } from 'components/Notification/ToastNotification'
import { mensajeDeError } from 'utils/apiError'

const ConfirmComprarEnCeroModal = ({ idProveedor, resetFilter }) => {
  const { closeModal } = useModal()
  const { comprarEnOtraOcasion, loading } = useCarrito()

  const content = {
    type: 'info',
    icon: 'bell',
    title: '¿Estás seguro que no querés comprar en esta ocasión?',
    text: [
      'Si seleccionas ',
      'CONFIRMAR ',
      'el pedido para este proveedor ',
      'se consolidará en cero en este cronograma',
    ],
    primaryButton: {
      function: async () => {
        try {
          await comprarEnOtraOcasion(idProveedor)
        } catch (error) {
          // El backend rechaza la carga en cero cuando el proveedor ya no forma
          // parte del cronograma.
          closeModal()
          showToast(
            mensajeDeError(error, 'No se pudo cargar el proveedor en cero.'),
            'error',
          )
          return
        }
        showToast(
          'El proveedor fue desactivado para esta ocasión de manera exitosa',
          'validacion',
        )
        closeModal()
        resetFilter()
      },
      text: 'Confirmar',
    },
    secondaryButton: {
      function: () => {
        closeModal()
      },
      text: 'Volver y revisar',
    },
    loading,
  }
  return <Modal content={content} idProveedor={idProveedor}></Modal>
}

export default ConfirmComprarEnCeroModal
